import { render, staticRenderFns } from "./SpuServicesModal.vue?vue&type=template&id=514c7988&scoped=true"
import script from "./SpuServicesModal.vue?vue&type=script&lang=ts"
export * from "./SpuServicesModal.vue?vue&type=script&lang=ts"
import style0 from "./SpuServicesModal.vue?vue&type=style&index=0&id=514c7988&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514c7988",
  null
  
)

export default component.exports